<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
      ]"
      :is-print="isPrint"
    />

    <!-- 작업장 수시점검 -->
    <TableInspectMerge :is-print="isPrint" :is-readonly="board.readonly" title="작업장 수시점검" tableHeaderTitle="자가진단 항목" :isNote="false" v-model="form.inspectList" class="mt-28px" />

    <!--    사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" section-title="사진대지" placeholder="00센터 신축현장 점검" :is-print="isPrint" :readonly="board.readonly" class="mt-28px" />

    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-28px" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";

export default {
  components: {
    TableInspectMerge,
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        photoList: [],
        equipmentList: [],
        inspectList: [
          {
            content: "안전관리자 지정 여부",
            isChecked: "",
            title: "안전보건관리체제",
          },
          {
            content: "보건관리자 지정 여부",
            isChecked: "",
            title: "안전보건관리체제",
          },
          {
            content: "안전보건교육 실시 여부",
            isChecked: "",
            title: "안전보건관리체제",
          },
          {
            content: "교육결과 기록보존상태",
            isChecked: "",
            title: "안전보건관리체제",
          },
          {
            content: "안전관리비 적정계상 여부",
            isChecked: "",
            title: "산업안전 보건관리비",
          },
          {
            content: "안전관리비 집행실태(타목적, 용도외 사용 등)",
            isChecked: "",
            title: "산업안전 보건관리비",
          },
          {
            content: "항목별 적정비율 집행 여부",
            isChecked: "",
            title: "산업안전 보건관리비",
          },
          {
            content: "보호구 적격품(검정) 구입 여부",
            isChecked: "",
            title: "개인보호구 지급",
          },
          {
            content: "개인보호구 지급 여부",
            isChecked: "",
            title: "개인보호구 지급",
          },
          {
            content: "개인보호구 착용 여부 (방진마스크, 귀마개, 안전모, 안전대, 안전화 등)",
            isChecked: "",
            title: "개인보호구 지급",
          },
          {
            content: "유해･위험방지계획서 제출 및 이행 여부 등",
            isChecked: "",
            title: "기타 안전대책",
          },
          {
            content: "위험물(인화성 물질 등) 관리 상태",
            isChecked: "",
            title: "기타 안전대책",
          },
          {
            content: "화재예방 대책(소화기 비치 비상 연락망 편성 등)",
            isChecked: "",
            title: "기타 안전대책",
          },
          {
            content: "위험, 주의, 경고 등 표지판 설치 상태",
            isChecked: "",
            title: "기타 안전대책",
          },
          {
            content: "작업장 내 자재의 정리 정돈 및 안전통로 확보 상태",
            isChecked: "",
            title: "기타 안전대책",
          },
        ],
        fileList: [],
      },
    };
  },
};
</script>
